import { type AccessDeclaration, requireRole } from '../access';

/**
 * Who may see what a terminal could not deliver.
 *
 * Declared here rather than inline in the route table because two things read
 * it: the guard, and the count in the back-office header that links to it. A
 * link drawn from a second opinion about who may open a screen is how somebody
 * is shown a control that then refuses them — `navigation.ts` avoids that for
 * every advertised route by filtering the table through `decideAccess`, and this
 * route is not advertised, so it needs its own way of saying it once.
 *
 * **`OWNER` and `MANAGER`, and no lower.** The rows name staff codes and what
 * those people were doing, and this app treats a list of staff codes as
 * administrative everywhere else — `/users` and `/staffing` are owner-only for
 * that reason, and the desktop half is stricter still, letting the *count* of a
 * roster cross to the renderer but never who is on it. A cashier admitted here
 * would read their colleagues off whichever till they were standing at.
 *
 * The manager is in because FR-111 is explicit that the owner and manager roles
 * reach every outlet **in the back office** without an assignment, and a
 * terminal's stuck queue is an operational record of an outlet rather than
 * identity administration. The person who deals with a till that has stopped
 * delivering is usually the manager standing in the park, and owner-only would
 * leave the screen shut in the situation it exists for.
 *
 * **This declaration is doing more work than most.** The usual answer — the role
 * here is cosmetic, the server decides — does not apply, because there is no
 * request behind this screen for the server to refuse. Whatever it admits, sees
 * the data. It is also why the session is never revalidated while this screen is
 * open: the API's idle window is discovered by a request being refused, and this
 * screen makes none.
 */
export const queuedWritesAccess: AccessDeclaration = requireRole('OWNER', 'MANAGER');
